// ============================
import { useEffect, useState } from "react";


export function useTheme() {
const [isLight, setIsLight] = useState(() => {
  if (typeof window === 'undefined') return false;
  const saved = localStorage.getItem('theme');
  if (saved) return saved === 'light';
  // Default to dark if nothing saved
  return false;
});



useEffect(() => {
localStorage.setItem('theme', isLight ? 'light' : 'dark');
}, [isLight]);


const classes = {
  pageBg: isLight ? 'bg-white text-slate-800' : 'bg-slate-950 text-slate-100',
  cardBg: isLight ? 'bg-white border-slate-300 shadow-sm' : 'bg-white/5 border-white/10',
  sectionTint: isLight ? 'bg-slate-100' : 'bg-slate-950/60',
  sectionTint2: isLight ? 'bg-slate-200' : 'bg-slate-950/80',
  gradientBg: isLight 
    ? 'from-white via-slate-100 to-slate-200' 
    : 'from-slate-900 via-slate-950 to-slate-950',
};



return { isLight, setIsLight, classes };
}